import React, {Component} from 'react';
import {NavLink} from 'reactstrap';
import PropTypes from 'prop-types';
import './BackButtonComponent.css';
import IconContainer from "../iconContainer/IconContainer";
import {Link} from "react-router-dom";

class BackButtonComponent extends Component {
    render() {
        return (
            <div className="back-button-container">
                <NavLink tag={Link} to={this.props.path} className='back-button-nav-link' title={this.props.label}>
                    <IconContainer className='back-button-icon' icon='arrow_back'/>
                    {this.props.label}
                </NavLink>
            </div>
        );
    }
}

BackButtonComponent.propTypes = {
    path: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
};

export default BackButtonComponent;



// WEBPACK FOOTER //
// ./src/components/commonComponents/backButtonComponent/BackButtonComponent.js